module.exports = __webpack_public_path__ + "static/the-only-plane-in-the-sky-a0eeb6b719b0da20217af45fcb0b732e.jpg";